import { createFileRoute } from "@tanstack/react-router";
import InspectionsPage from "@/app/inspections/page";

export const Route = createFileRoute("/inspections/")({
  component: InspectionsPage,
});
